export default __webpack_public_path__ + "img/benefits6.4fbf6949.svg";